'use strict'

/**
 * Return scroll directive.
 * Directive listening scroll action.
 *
 * @returns {{mounted: mounted}}
 */
const scrollDirective = () => {
	return {
		mounted: (el, binding, vnode, oldVnode) => {
			let f = function (evt) {
				if (binding.value(evt, el, binding, vnode, oldVnode)) {
					window.removeEventListener('scroll', f)
				}
			}
			window.addEventListener('scroll', f)
		}
	}
}

export default scrollDirective
